// Not bank gateways: installments, wallet, wallet top-up variants, payment links.
const isBankGateway = (method: string) => !/^(snapp|wallet|link)|_topups/i.test(method);

/**
 * The bank gateway just failed — continuing on another bank (saman ↔ mellat) is more likely to go
 * through than repeating the same one. Non-bank methods and single-bank lists stay as they were.
 */
export const pickRetryPaymentMethod = (previous: string | undefined, available: string[]) => {
  if (!previous || !isBankGateway(previous)) return previous;
  return available.find(method => method !== previous && isBankGateway(method)) ?? previous;
};

/** Same, against the methods katibe offers this center right now; any failure keeps `previous`. */
// katibe returns an empty list without the amount (rial) and timezone the factor sends.
export const paymentMethodsQuery = (centerId: string, amountRial?: number) => ({
  center_id: centerId,
  ...(amountRial && { amount: String(Math.round(amountRial)) }),
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
});

export const resolveRetryPaymentMethod = async (previous: string | undefined, centerId: string, amountRial?: number) => {
  if (!previous) return previous;
  try {
    const { getPaymentMethods } = await import('@/common/apis/services/factor/paymentMethods');
    const { data } = await getPaymentMethods(paymentMethodsQuery(centerId, amountRial));
    return pickRetryPaymentMethod(previous, (data?.data?.payment_methods ?? []).map(m => m.payment_method));
  } catch {
    return previous;
  }
};
